/**
 * Login.js
 * [Managed by LoginComponent]
 * [Housed in login tab]
 * Takes care of login actions (delegating to the login handler)
 * and forget password options. This is a BS4 carousel.
 * (....BS here means bootstrap btw)
 * @author Jaiwardhan Swarnakar
 */
import React from 'react';
import BaseComponent from '../../BaseComponent';
import LocUtils from '../../../util/localization/LocUtils'
import '../../../../styles/generic.css'
import './LoginV2.css'
import $ from 'jquery'
import Utils from '../../../managers/Network/Utils';
import Toast from '../../../util/toasts/Toast';
import ServiceLocator from '../../../ServiceLocator';
import Button from '../buttons/Buttons';
import DataStore from "../../../data/DataStore";
import WithoutFacebookLogin from "./withoutFacebookLogin";
import GoogleButton from "../buttons/GoogleButton";

class LoginV2 extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            loginType: "0", // 0 => never logged in before, 1 => logged in via facebook, 2 => logged in via email and password
            username: this.props.cookieEmail,
            password: "",
            forgetEmail: this.props.cookieEmail,
            isGoogleSSOLoggedIn: this.props.isGoogleSSOLoggedIn,
            engaged: false,
            keepSignedIn: true,
            validation: {
                username: false,
                password: false,
                forgetEmail: false,
            },
            errorMsg: "",
            source: 2,
            fromSignup: false
        };
        /** Properties passed */
        this.loginAuthHandler = props.loginAuthHandler;
        this.loginFBHandler = props.loginFBHandler;
        this.loginGoogleHandler = props.loginGoogleHandler;
        this.forgotPasswordHandler = props.forgotPasswordHandler;
        this.resetFbLoginClick = props.resetFbLoginClick;

        /** Internal handlers */
        this.onLoginButtonClick = this.onLoginButtonClick.bind(this);
        this.onChangeField = this.onChangeField.bind(this);
        this.onForgotPasswordLinkClick = this.onForgotPasswordLinkClick.bind(this);
        this.onBackToLoginButtonClick = this.onBackToLoginButtonClick.bind(this);
        this.onForgotPasswordSubmitClick = this.onForgotPasswordSubmitClick.bind(this);
        this.onForgotPasswordUnderstoodButtonClick = this.onForgotPasswordUnderstoodButtonClick.bind(this);
        this.onEmailLoginClick = this.onEmailLoginClick.bind(this);
        this.onCheckboxChange = this.onCheckboxChange.bind(this);
        this.onEmailNotVerified = this.onEmailNotVerified.bind(this)
        this.showSlides = this.showSlides.bind(this)

        // Subscription to turn of the field editing 
        this.onEngageFinish = this.onEngageFinish.bind(this);
        if (!ServiceLocator.Events.isSubscribed("ZDC_LOGIN_DIALOG", this.onEngageFinish)) ServiceLocator.Events.subscribe("ZDC_LOGIN_DIALOG", this.onEngageFinish);
        if (!ServiceLocator.Events.isSubscribed("ZDC_FORGET_PASSWORD", this.onEngageFinish)) ServiceLocator.Events.subscribe("ZDC_FORGET_PASSWORD", this.onEngageFinish);
        if (!ServiceLocator.Events.isSubscribed("FACEBOOK_LOGIN", this.onEngageFinish)) ServiceLocator.Events.subscribe("FACEBOOK_LOGIN", this.onEngageFinish);

    }

    componentDidMount() {
        this.setState({
            //username: this.props.preloadedData.email,
            loginType: this.props.loginType,
            isGoogleSSOLoggedIn: this.props.isGoogleSSOLoggedIn
        })
        this.showSlides();
    }

    componentWillUnmount() {
        ServiceLocator.Events.unsubscribe("ZDC_LOGIN_DIALOG", this.onEngageFinish);
        ServiceLocator.Events.unsubscribe("ZDC_FORGET_PASSWORD", this.onEngageFinish);
        ServiceLocator.Events.unsubscribe("FACEBOOK_LOGIN", this.onEngageFinish);
    }

    pageActions = {
        validityChecks: () => {
            const { forgetEmail, password, username } = this.state;
            let verdict = this.state;
            if (!password || password.length < 7) verdict.validation.password = true;
            if (!username || username.length === 0 || !Utils.ValidateEmail(username)) verdict.validation.username = true;
            if (!forgetEmail || forgetEmail.length === 0 || !Utils.ValidateEmail(forgetEmail)) verdict.validation.forgetEmail = true;
            this.setState(verdict);
        },
        resetValidityCheck: (d = {}) => {
            let verdict = this.state;
            Object.keys(d).forEach(k => {
                if (this.state.validation[k] !== undefined) verdict.validation[k] = false;
            })
            this.setState(verdict);
        },
        resetErrors: () => {
            let verdict = this.state;
            verdict.validation.username = false;
            verdict.validation.password = false;
            verdict.validation.forgetEmail = false;
            this.setState(verdict);
        }
    }


    /** Subscription handler */
    onEngageFinish(evt) {
        this.setState({
            engaged: false
        })
    }

    onEmailLoginClick() {
        this.resetFbLoginClick();
        this.setState({
            loginType: "2"
        });
    }

    showSlides(slideNumber = 0) {
        let slides = document.getElementsByClassName("mySlides");
        for (let i = 0; i < slides.length; i++) {
            slides[i].style.display = "none";
            slides[i].className = slides[i].className.replace(" fade", "");
            slides[i].className += " fade";
        }
        slides[slideNumber].className = slides[slideNumber].className.replace(" fade", "");
        slides[slideNumber].style.display = "block";
    }

    /** PANE1: When login button is clicked */
    onLoginButtonClick(evt) {
        // In the event that the user attempts multiple button click
        // we would want to avoid it till the time the network has 
        // resolved itself
        if (this.state.engaged) return;

        this.pageActions.validityChecks();



        if (Utils.ValidateEmail(this.state.username) && Utils.ValidatePassword(this.state.password)) {
            this.setState({
                engaged: true
            })
            this.loginAuthHandler(this.state);
        }

        if (!Utils.ValidateEmail(this.state.username) && !Utils.ValidatePassword(this.state.password)) {
            this.setState({
                errorMsg: LocUtils.TPure("toasts.forget_password_invalid_email_password")
            });
        } else if (!Utils.ValidateEmail(this.state.username)) {
            this.setState({
                errorMsg: LocUtils.TPure("toasts.forget_password_invalid_email")
            });
        } else if (!Utils.ValidatePassword(this.state.password)) {
            this.setState({
                errorMsg: LocUtils.TPure("toasts.forget_password_invalid_password")
            });
        }

        // Clear password field if incorrect/invalid password is entered
        if (this.state.validation.password || this.state.validation.username) {
            this.setState({
                password: ''
            });
        }
    }

    /** PANE1: when user click on the forgot password indicator */
    onForgotPasswordLinkClick(evt) {
        this.pageActions.resetErrors();
        $("#login-carousel").carousel(1);
    }

    /** PANE2: When user wants to go back to login pane (back button) */
    onBackToLoginButtonClick(evt) {
        this.pageActions.resetErrors();
        $("#login-carousel").carousel(0);
    }

    onCheckboxChange(data) {
        var oldKeepSignedIn = this.state.keepSignedIn;
        this.setState({
            keepSignedIn: !oldKeepSignedIn,
        });
    }

    /** PANE2: When user submits a mail for forgotten password account */
    onForgotPasswordSubmitClick(evt) {
        // In the event that the user attempts multiple button click
        // we would want to avoid it till the time the network has 
        // resolved itself
        if (this.state.engaged) return;
        this.pageActions.validityChecks();
        if (Utils.ValidateEmail(this.state.forgetEmail)) {
            this.setState({
                engaged: true
            })
            this.props.forgotPasswordHandler(
                this.state.forgetEmail,
                (resp => { resp["e"] === 2 ?
                    this.onEmailNotVerified(this.state.forgetEmail)
                    : resp["e"] === 1  && resp["errors"] && resp["errors"].includes(1222)?
                        Toast.Show({
                            message: LocUtils.TPure("toasts.account_update_error_no_zdc_account"),
                            severity: Toast.SEVERITY_CODES.ERROR
                        })
                        : $("#login-carousel").carousel(2) }),
                (err => {
                    super.error("Error when sending data", err);
                    Toast.Show({
                        message: LocUtils.TPure("toasts.something_went_wrong"),
                        severity: Toast.SEVERITY_CODES.ERROR
                    })
                })
            )
        } else {
            Toast.Show({
                message: LocUtils.TPure("toasts.forget_password_invalid_email"),
                severity: Toast.SEVERITY_CODES.ERROR
            })
        }
    }

    /** PANE3: User acknowledges that email was sent */
    onForgotPasswordUnderstoodButtonClick(evt) {
        this.pageActions.resetErrors();
        $("#login-carousel").carousel(0);
    }


    onChangeField(data) {
        this.pageActions.resetValidityCheck(data);
        this.props.resetInvalidCreds();
        this.setState(data);
    }

    onEmailNotVerified(data){
        DataStore.LocalStorage.Store("emailIdToSendVerification", data);
        $("#loginModalCenter").modal("hide");
        $("#emailVerificationModal").modal('show')
    }


    showErrorMsg() {
        return (!!this.state.validation.username || !!this.state.validation.password || (this.props.invalidCredentials && this.props.source === 2));
    }

    render() {

        const getNAOnUndefined = (value) => {
            return (value && value.toString().length) ? value : "NA"
        }

        return (
            <div aria-labelledby={this.props.tabRef} id={this.props.id}>
                <div className="row login-row no-gutters">
                    {!this.props.isZDCMigrationModule2 &&
                        <div className="col-sm-12 col-12 col-md-6 col-lg-6 left-section" style={{padding: "20px"}}>
                            {!(this.props.showGmailNotLinked || (Object.keys(this.props.googleLoginBlobData).length !== 0)) && <div className="slideshow-container">

                                <div className="mySlides fade">
                                    <div className="login-info-text">{LocUtils.TPure("dialogs.GoogleSSO.loginDialogWithGoogle.gif1Text")}</div>
                                    {/*<div className="numbertext">1 / 4</div>*/}
                                    <img
                                        src={process.env.REACT_APP_ASSET_PATH + "/dialogs/google/Google SSO & Face book-.gif"}
                                        alt="Tutorial 1"
                                        style={{width: "100%", borderRadius: "10px"}}
                                    />
                                </div>

                                <div className="mySlides fade">
                                    <div className="login-info-text">{LocUtils.TPure("dialogs.GoogleSSO.loginDialogWithGoogle.gif2Text")}</div>
                                    {/*<div className="numbertext">2 / 4</div>*/}
                                    <img
                                        src={process.env.REACT_APP_ASSET_PATH + "/dialogs/google/UserId & Pass page.gif"}
                                        alt="Tutorial 2"
                                        style={{width: "100%", borderRadius: "10px"}}
                                    />
                                </div>

                                <div className="mySlides fade">
                                    <div className="login-info-text">{LocUtils.TPure("dialogs.GoogleSSO.loginDialogWithGoogle.gif3Text")}</div>
                                    {/*<div className="numbertext">3 / 4</div>*/}
                                    <img
                                        src={process.env.REACT_APP_ASSET_PATH + "/dialogs/google/FaceBook page.gif"}
                                        alt="Tutorial 3"
                                        style={{width: "100%", borderRadius: "10px"}}
                                    />
                                </div>

                                <div className="mySlides fade">
                                    <div className="login-info-text">{LocUtils.TPure("dialogs.GoogleSSO.loginDialogWithGoogle.gif4Text")}</div>
                                    {/*<div className="numbertext">4 / 4</div>*/}
                                    <img
                                        src={process.env.REACT_APP_ASSET_PATH + "/dialogs/google/Start New Farm.gif"}
                                        alt="Tutorial 4"
                                        style={{width: "100%", borderRadius: "10px"}}
                                    />
                                </div>

                            </div>}
                            {this.props.showGmailNotLinked && <div className="gif-container">
                                <div>
                                    <div className="login-info-text">{LocUtils.TPure("dialogs.GoogleSSO.loginDialogWithGoogle.gif5Text")}</div>
                                    <img
                                        src={process.env.REACT_APP_ASSET_PATH + "/dialogs/google/Google SSO & Face book-.gif"}
                                        alt="Tutorial fetch data"
                                        style={{width: "100%", borderRadius: "10px"}}
                                    />
                                </div>
                            </div>}
                            {(Object.keys(this.props.googleLoginBlobData).length !== 0) &&
                                <div className="google-sso-show-details-container">
                                    <div className="login-info-text">{LocUtils.TPure("dialogs.GoogleSSO.detailsDialogWithGoogle.loginInfoText1")}</div>
                                    <br/>
                                    <div className="input-group mb-3 text-left profile-text pt-2">
                                        <table style={{"color": "antiquewhite"}}>
                                            <thead>
                                                <tr><td>Name: {getNAOnUndefined(this.props.googleLoginBlobData.firstName)}</td></tr>
                                            </thead>
                                            <tbody>
                                                <tr><td>Level: {getNAOnUndefined(this.props.googleLoginBlobData.level)}</td></tr>
                                                <tr><td>Last Login Date: {new Date(this.props.googleLoginBlobData.lastLoginTime).toDateString()}</td></tr>
                                                <tr><td>Farm Bucks: {getNAOnUndefined(this.props.googleLoginBlobData.cash)}</td></tr>
                                                <tr><td>Coins: {getNAOnUndefined(this.props.googleLoginBlobData.coins)}</td></tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <br/>
                                    <div className="login-info-text">{LocUtils.TPure("dialogs.GoogleSSO.detailsDialogWithGoogle.loginInfoText2")}</div>
                                    <br/>
                                    <Button onClick={this.props.loginToZDCUsingGToken}
                                            extraClass="form-signin-button"
                                            message="Load Farm"/>
                                </div>}
                            <br/>

                            <p className="login-info-text">
                                {LocUtils.T("login.signup_form_terms", {
                                    button_text: LocUtils.T("login.signup_connect"),
                                })}
                            </p>
                            <ul className="login-info-text">
                                <li>
                                    <a
                                        target="_blank"
                                        style={{color: "white", textDecoration: "underline"}}
                                        rel="noopener noreferrer"
                                        href="http://company.zynga.com/legal/terms-of-service"
                                    >
                                        {LocUtils.T("login.signup_terms_of_service")}
                                    </a>
                                </li>
                                <li>
                                    <a
                                        target="_blank"
                                        style={{color: "white", textDecoration: "underline"}}
                                        rel="noopener noreferrer"
                                        href="https://www.take2games.com/privacy"
                                    >
                                        {LocUtils.T("login.signup_privacy_policy")}
                                    </a>
                                </li>
                            </ul>
                        </div>}
                    {this.props.isZDCMigrationModule2 &&
                        <WithoutFacebookLogin
                            loginFBHandler={this.loginFBHandler}
                            loginGoogleHandler={this.loginGoogleHandler}
                            isGoogleSSOActive={this.props.isGoogleSSOActive}
                            source={"emailLogin"}
                            loginErrMsg={this.props.loginErrMsg}
                            parentSwitchTabHandle={this.props.parentSwitchTabHandle}
                        />}
                    <div className="col col-md-6 col-lg-6 signup-fb-container signup-fb-container-v2"
                         style={{padding: "17px"}}>
                        <div
                            id="login-carousel"
                            className="carousel slide full-ht"
                            data-keyboard="false"
                            data-ride="carousel"
                            data-interval="false"
                        >
                            <div className="carousel-inner carousel-min-pad full-ht">
                                {/* The login form */}
                                <div className="carousel-item active full-ht">
                                    {/* The form */}
                                    <div className="row no-gutters">
                                        <div className="col">
                                            <p className="h4" style={{color: "black", textAlign: "left"}}>
                                                {(Object.keys(this.props.googleLoginBlobData).length !== 0) ? LocUtils.TPure("dialogs.GoogleSSO.detailsDialogWithGoogle.loginInfoText3") :
                                                    ((this.state.loginType === "0") ?
                                                    LocUtils.T("login.fb_signup_title") :
                                                    LocUtils.T("login.login_title"))}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row no-gutters">
                                        <div className="col">
                                            <p className="h5" style={{color: "black", textAlign: "left"}}>
                                                {(Object.keys(this.props.googleLoginBlobData).length !== 0) ? LocUtils.TPure("dialogs.GoogleSSO.detailsDialogWithGoogle.loginInfoText4") :
                                                    ((this.state.loginType === "0") ?
                                                    LocUtils.T("login.fb_signup_subtitle") :
                                                    LocUtils.T("login.login_greet"))}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="input-group mb-3 text-left">
                                        <div className="invalid-tooltip error-message-container" style={{
                                            "position": "static",
                                            "display": this.showErrorMsg() ? "block" : "none"
                                        }}>
                                            {(this.props.invalidCredentials && this.props.source === 2) ? LocUtils.TPure("toasts.invalid_credentials") : this.state.errorMsg}
                                        </div>
                                    </div>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                                <span
                                                    className="input-group-text"
                                                    id="basic-addon1"
                                                >
                                                    <i
                                                        className="fa fa-envelope"
                                                        aria-hidden="true"
                                                    ></i>
                                                </span>
                                        </div>
                                        <input
                                            disabled={this.state.engaged}
                                            type="email"
                                            onChange={(evt) => {
                                                if (evt) evt.preventDefault();
                                                this.onChangeField({
                                                    username: evt.target.value,
                                                });
                                            }}
                                            placeholder={LocUtils.TPure("login.email")}
                                            className={
                                                ((!!this.state.validation.username || (!!this.props.invalidCredentials && this.props.source === 2))
                                                    ? "is-invalid no-cross-img "
                                                    : "") + "form-control"
                                            }
                                            aria-label="Email"
                                            id={this.props.id + "-email"}
                                            value={this.state.username}
                                        />
                                    </div>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                                <span
                                                    className="input-group-text"
                                                    id="basic-addon1"
                                                >
                                                    <i className="fa fa-key" aria-hidden="true"></i>
                                                </span>
                                        </div>
                                        <input
                                            disabled={this.state.engaged}
                                            type="password"
                                            onChange={(evt) => {
                                                if (evt) evt.preventDefault();
                                                this.onChangeField({
                                                    password: evt.target.value,
                                                });
                                            }}
                                            placeholder={LocUtils.TPure("login.password")}
                                            className={"form-control"}
                                            aria-label="Password"
                                            id={this.props.id + "-password"}
                                        />
                                    </div>
                                    <div className="row no-gutters">
                                        {/* <--- modal helper for logging in and forgot password starts --> */}
                                        <div className="col-sm-12">
                                            <div className="mt-0">
                                                <div className="mt-8n" style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    paddingInline: "15px"
                                                }}>
                                                    <div style={{display: 'flex', alignItems: 'center'}}>
                                                        <input type="checkbox"
                                                               disabled={this.state.engaged}
                                                               style={{accentColor: "grey"}}
                                                               onChange={(evt) => {
                                                                   this.onCheckboxChange({
                                                                       keepSignedIn: evt.target.value,
                                                                   });
                                                               }}
                                                               defaultChecked={this.state.keepSignedIn}
                                                               id="keep-logged-in" name="keep-logged-in"/>
                                                        <label htmlFor="keep-logged-in"
                                                               className="keep-logged-in-text-v2">{LocUtils.T("login.keep_logged_in")}</label>
                                                    </div>
                                                    <small id="modalHelp"
                                                           className="form-text input-text-below-v2 mt-0 badge badge-secondary fp-badge-custom"
                                                           onClick={this.onForgotPasswordLinkClick}>
                                                        {LocUtils.T("login.login_forgot_password")}
                                                    </small>
                                                    <small className="form-text input-text-below-v2 mt-1 badge badge-secondary fp-badge-custom"
                                                           onClick={() => { window.open("https://zyngasupport.helpshift.com/hc/en/10-farmville-2/faq/22522-why-am-i-unable-to-log-in-with-facebook/", "_blank"); }}>
                                                        {LocUtils.T("login.support")}
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <--- modal helper for logging in and forgot password ends --> */}
                                    </div>
                                    <div>
                                        <Button
                                            onClick={this.onLoginButtonClick}
                                            onMouseOver={() => {this.showSlides(1);}}
                                            extraClass="form-signin-button-max-width-v2"
                                            message={
                                                this.state.engaged ? (
                                                    <span>
                                                                <i
                                                                    className="fa fa-circle-o-notch fa-spin fa-3x fa-fw"
                                                                    style={{fontSize: "1rem"}}
                                                                ></i>
                                                        &nbsp;{LocUtils.T("login.login_btn")}
                                                            </span>
                                                ) : (
                                                    LocUtils.T("login.login_btn")
                                                )
                                            }
                                        />
                                    </div>
                                    {!this.state.isGoogleSSOLoggedIn && !this.props.showGmailNotLinked && <div>
                                        <GoogleButton
                                            onClick={() => {this.loginGoogleHandler();}}
                                            onMouseOver={() => {this.showSlides();}}
                                            extraClass="form-signin-button-max-width-v2"
                                            message={LocUtils.T("login.google_login_text")}
                                        />
                                    </div>}
                                    {this.state.isGoogleSSOLoggedIn && !this.props.showGmailNotLinked && <div>
                                        <GoogleButton
                                            type="loggedIn"
                                            onClick={() => {this.loginGoogleHandler();}}
                                            onMouseOver={() => {this.showSlides();}}
                                            extraClass="form-signin-button-max-width-v2"
                                            message={this.props.googleProfileName}
                                            imgSrc={this.props.googleProfilePicURL}
                                        />
                                    </div>}
                                    {this.props.isZDCMigrationModule2 &&
                                        <div className="input-group mb-3 text-center content-center">
                                            <Button
                                                onClick={() => {
                                                    ServiceLocator.ZTrack.Cast({
                                                        counter: "dialog",
                                                        kingdom: "click",
                                                        phylum: this.props.source,
                                                        zClass: "fbconnect",
                                                        family: "zdc_register",
                                                        value: ServiceLocator.SocialNetworkManager.Me.Identity.getDeviceID()
                                                    });
                                                    this.loginFBHandler();
                                                }}
                                                onMouseOver={() => {this.showSlides(2);}}
                                                extraClass="h6"
                                                severity="link"
                                                message={LocUtils.T("login.signup_connect")}
                                            />
                                        </div>}
                                    <div style={{"bottom": "-15px"}}>
                                        <div>
                                            <Button
                                                onClick={() => {
                                                    ServiceLocator.ZTrack.Cast({
                                                        counter: "dialog",
                                                        kingdom: "click",
                                                        phylum: this.props.source,
                                                        zClass: "fbconnect",
                                                        family: "zdc_register",
                                                        value: ServiceLocator.SocialNetworkManager.Me.Identity.getDeviceID()
                                                    });
                                                    this.loginFBHandler();
                                                }}
                                                onMouseOver={() => {this.showSlides(2);}}
                                                extraClass="button-text-facebook"
                                                severity="link"
                                                message={LocUtils.T("login.signup_connect")}
                                            />
                                        </div>
                                        <div>
                                            <Button
                                                onClick={() => {
                                                    ServiceLocator.ZTrack.Cast({
                                                        counter: "dialog",
                                                        kingdom: "click",
                                                        phylum: "emailLogin",
                                                        zClass: "signup",
                                                        family: "zdc_register",
                                                        value: ServiceLocator.SocialNetworkManager.Me.Identity.getDeviceID()
                                                    });
                                                    this.props.parentSwitchTabHandle("signup")
                                                }}
                                                onMouseOver={() => {this.showSlides(3);}}
                                                extraClass="button-text-signup"
                                                severity="start-new"
                                                message={LocUtils.T("login.signup_confirm_deny")}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* The forget password form */}
                                <div className="carousel-item forgot-margins">
                                    <div className="input-group mb-3 text-left">
                                        <h3 style={{color: "black"}}>
                                            {LocUtils.T("login.login_forgot_password_title")}
                                        </h3>
                                    </div>
                                    <div className="input-group mb-3 text-left">
                                        <h5 style={{color: "black"}}>
                                            {LocUtils.T("login.login_forgot_password_desc")}
                                            <br/>
                                        </h5>
                                    </div>
                                    <div
                                        className={
                                            (!!this.state.validation.forgetEmail
                                                ? "inp-error"
                                                : "") + " input-group mb-3"
                                        }
                                    >
                                    <div className="input-group-prepend">
                                                <span
                                                    className="input-group-text"
                                                    id="basic-addon1"
                                                >
                                                    <i
                                                        className="fa fa-envelope"
                                                        aria-hidden="true"
                                                    ></i>
                                                </span>
                                        </div>
                                        <input
                                            disabled={this.state.engaged}
                                            type="email"
                                            onChange={(evt) => {
                                                if (evt) evt.preventDefault();
                                                this.onChangeField({
                                                    forgetEmail: evt.target.value,
                                                });
                                            }}
                                            placeholder={LocUtils.TPure("login.email")}
                                            className="form-control"
                                            aria-label="Email"
                                            id={this.props.id + "-email-forgot"}
                                            value={this.state.forgetEmail}
                                        />
                                    </div>
                                    <Button
                                        onClick={this.onForgotPasswordSubmitClick}
                                        extraClass="form-signin-button"
                                        message={LocUtils.T(
                                            "login.login_forgot_password_send_btn"
                                        )}
                                        severity="default"
                                    />
                                    <hr />
                                    <i
                                        className="div-button small-font badge badge-secondary"
                                        onClick={this.onBackToLoginButtonClick}
                                    >
                                        &lt; {LocUtils.T("login.back")}
                                    </i>
                                </div>

                                {/* The mail sent for forget password */}
                                <div className="carousel-item email-sent-margins">
                                    <div className="input-group mb-3 text-left">
                                        <h3 style={{color: "black"}}>{LocUtils.T("login.login_email_sent_title")}</h3>
                                    </div>
                                    <div className="input-group mb-3 text-left">
                                        <h5 style={{color: "black"}}>{LocUtils.T("login.login_email_sent_desc")}</h5>
                                    </div>
                                    <div className="input-group mb-3 text-left">
                                        <Button
                                            onClick={this.onForgotPasswordUnderstoodButtonClick}
                                            extraClass="form-signin-button"
                                            message={LocUtils.T(
                                                "login.login_email_sent_confirm_btn"
                                            )}
                                            severity="default"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>


                </div>

            </div>
        );
    }
}

export default LoginV2;